import { z } from 'zod';
import { TimestampLike, safeText } from './common.js';

export const SubjectDoc = z.object({
  clientId: z.string().min(1),
  name: safeText('Subject name', { max: 120 }),
  entityType: z.enum(['person', 'company', 'entity']),
  isActive: z.boolean().default(true),
  createdAt: TimestampLike,
  sortOrder: z.number().int().default(0),
});
export type SubjectDoc = z.infer<typeof SubjectDoc>;
